<template>
  <div id="map" class="google-map"></div>
</template>

<script>
import { loadGoogleMaps } from '@/web/util';

export default {
  props: {
    latitude: {
      type: String,
      required: true,
    },
    longitude: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      default: '',
    },
    hideTags: {
      type: Boolean,
      default: false,
    },
    popup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {
    loadGoogleMaps(() => {
      const coordinates = new google.maps.LatLng(this.latitude, this.longitude);
      const styledMap = new google.maps.StyledMapType(
        [
          { elementType: 'geometry', stylers: [{ color: '#E1E8EF' }] },
          { elementType: 'labels.text.fill', stylers: [{ color: '#7592AB' }] },
          { elementType: 'labels.text.stroke', stylers: [{ color: '#FFFFFF' }] },
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [{ color: '#C9D4E0' }],
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'geometry.stroke',
            stylers: [{ color: '#C9D4E0' }],
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#7592AB' }],
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{ color: '#D4DEE6' }],
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: this.hideTags ? 'off' : 'on' }],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{ color: '#EDF7F6' }],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [{ color: '#EDF7F6' }],
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#7592AB' }],
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [{ color: '#EDF7F6' }],
          },
          {
            featureType: 'transit.line',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#7592AB' }],
          },
        ],
        { name: 'Styled Map' }
      );
      const map = new google.maps.Map(document.getElementById('map'), {
        center: coordinates,
        zoom: 18,
        disableDefaultUI: true,
        mapTypeId: 'styled_map',
        zoomControl: true,
      });

      map.mapTypes.set('styled_map', styledMap);
      map.setMapTypeId('styled_map');

      const marker = new google.maps.Marker({
        position: coordinates,
        map,
        title: this.address,
        icon: '/img/web/icons/marker.svg',
      });

      if (this.popup) {
        marker.addListener('click', () => {
          const infowindow = new google.maps.InfoWindow({
            content:
              '<h3 style="font-size: 15px"><b>Trioteca</b></h3></br>' +
              this.address +
              '</br><div style="margin-top: .5rem"><b>Teléfono: </b><a href="tel:+34910054391" style="text-decoration: underline; color: blue">910 05 43 91</a></div>' +
              '<div style="margin-top: .5rem"><b>Horario de llamadas</b>: 9:00 - 21:00</div>',
          });
          infowindow.open(map, marker);
        });
      }
    });
  },
  methods: {},
};
</script>
